module.exports = __webpack_public_path__ + "static/media/undraw_startup_life.f640c6f4.svg";